import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { BListGroupItem, BRow, BCol } from 'bootstrap-vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import { CanvasEx } from '@/typings/canvas';
import { ElementsPageEps } from '@/typings/customilyElements/elementsPageEps';
import _ from 'underscore';

@Component({
    name: 'ListPageEps',
    components: {
        'b-list-group-item': BListGroupItem,
        'b-row': BRow,
        'b-col': BCol,
        'svg-icon': SvgIcon
    }
})
export default class ListPageEps extends Vue {
    @Prop({ default: null }) readonly canvas!: CanvasEx | null;
    @Prop({ default: 'Page' }) readonly collapseTitle!: string;
    @Prop({ default: true }) readonly enable!: boolean;
    collapsed = true;
    activePageEpsId: number | null = null;
    nestedList: ElementsPageEps[] = [];
    listPageEps: ElementsPageEps[] = [];

    @Watch('listPageEps')
    onListPageEpsChange() {
        const list: ElementsPageEps[] = [];

        let zIndex = 0;
        const _listPageEps = [...this.listPageEps];
        for (const eps of _listPageEps) {
            const element: ElementsPageEps = {
                ...eps,
                active: zIndex === 0,
                zIndex
            };
            list.push(element);
            zIndex++;
        }
        if (list.length === 0) {
            this.nestedList = [];
            return;
        }
        this.activePageEpsId = list[0].id;

        this.nestedList = _.sortBy(list, (item) => item.zIndex);
    }

    @Watch('activePageEpsId')
    onPageEpsSelect(pageEpsId: number) {
        this.$emit('element-selected', pageEpsId);
    }

    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }

    onElementClick(item: ElementsPageEps) {
        if (this.activePageEpsId == item.id) return;
        this.activePageEpsId = item.id;
    }

    isPageEpsActive(item: ElementsPageEps) {
        return this.activePageEpsId == item.id;
    }

    setPageEpsElements(listEPS: ElementsPageEps[]) {
        Vue.set(this, 'listPageEps', listEPS);
    }
}
